module.exports = __webpack_public_path__ + "static/media/l-form.f5a40d98.svg";